import { makeVar } from '@apollo/client'

import { UpdateQuoteAction } from '../generated/graphql'

export const quoteUpdateQueue = makeVar<UpdateQuoteAction[]>([])

export const queueQuoteUpdate = (update: UpdateQuoteAction) => quoteUpdateQueue([...quoteUpdateQueue(), update])
